
import pcPopup from '@/components/common/popup/pc-popup.vue'
import chooseCar from '@/components/choose-car.vue'
import {
  countAd,
  fetchSeriesList,
  fetSerialDetail,
  fetchAppUserInfo,
  postLotteryEnroll,
  fetchEncryptInfo,
  fetchVerifyCtrl,
} from '@/http/api'
import { getCookie } from '@/utils/cookie-storage'
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  onBeforeMount,
} from 'vue'
import { useStore } from 'vuex'
import { setTxtLength } from '@/utils/handle-text'
import { Toast } from 'vant'
import { useRoute } from 'vue-router'
import {
  getXunJiaInfo3Cookie,
  judgeEncryptPhoneIsSameEnv,
} from '@/composables/use-cookie-function'
export default defineComponent({
  components: {
    pcPopup,
    chooseCar,
  },
  name: '',
  emits: ['toggleTmReceiveRedPacketPopup', 'toggleTmReceiveSuccessPopup'],
  props: {
    isShowReceiveRedPacketPopup: {
      type: Boolean,
    },
    lotteryResultBO: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const win: any = window
    const route = useRoute()
    const store = useStore()
    const data = reactive({
      locationInfo: computed(() => store.state.locationInfo),
      appLoginCookieKey: computed(() => store.state.appLoginCookieKey),
      appLoginCookieValue: computed(() => store.state.appLoginCookieValue),
      browserEnv: store.state.browserEnv,
      seriesBOList: [] as any,
      postForm: {
        actId: 0,
        amount: 0,
        city: '',
        cityId: 0,
        currentFrom: '',
        locationMessage: '',
        locationType: 0,
        locationVersion: 0,
        pcsuv: '' as any,
        phone: '',
        encryptPhone: '',
        seriesBOList: [
          {
            brand: '',
            brandId: 0,
            serialGroupId: 0,
            serialGroupName: '',
            serialGroupPic: '',
          },
        ],
        source: 0,
        sourceDetail: 0,
      },
      isReadOnly: false,
      cxSelect: {} as any,
      checkBoxNeedVerify: false,
      carSelectVisible: false,
    })
    watch(
      () => props.isShowReceiveRedPacketPopup,
      (nVal, oVal) => {
        if (nVal === true) {
          // 每次都需获取后台最新配置
          methods.getSeriesList()
          let cookiePhoneObj: any = getXunJiaInfo3Cookie()
          if (data.browserEnv === 1) {
            data.isReadOnly = store.state.appPhone ? true : false
            data.postForm.phone = store.state.appPhone
              ? store.state.appSensitivePhone + '(上次使用)'
              : ''
            data.postForm.encryptPhone = store.state.appEncryptPhone
          } else {
            if (
              cookiePhoneObj &&
              cookiePhoneObj.phone &&
              cookiePhoneObj.encryptPhone &&
              judgeEncryptPhoneIsSameEnv(cookiePhoneObj.type)
            ) {
              data.isReadOnly = true
              data.postForm.phone = cookiePhoneObj.phone + '(上次使用)'
              data.postForm.encryptPhone = cookiePhoneObj.encryptPhone
            }
          }

          methods.getVerifyCtrl()
        }
      },
    )
    const methods = {
      // 获取验证码和勾选框状态
      async getVerifyCtrl() {
        if (data.browserEnv === 1) {
          // app
          data.postForm.source = 2
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          // h5或微信浏览器
          data.postForm.source = 1
        }
        const res: any = await fetchVerifyCtrl({ source: data.postForm.source })
        if (res.code === 200) {
          data.checkBoxNeedVerify = res.data.checkBoxNeedVerify
        }
      },
      // 获取车系列表数据
      async getSeriesList() {
        const res: any = await fetchSeriesList({ actId: route.query.actId })
        if (res.code === 200) {
          data.seriesBOList = res.data || []
          if (data.seriesBOList.length > 0) {
            data.seriesBOList.forEach((serial: any) => {
              serial.serialGroupName =
                setTxtLength(serial.serialGroupName, 6) || ''
            })
          }
        } else {
          Toast(res.messsage)
        }
      },
      // 选中车品牌
      async toChooseCar(res: any) {
        // 获取车系详情
        const serialDetail: any = await fetSerialDetail({
          serialGroupId: res.carSeries.id,
        })
        if (serialDetail.code === 200) {
          data.seriesBOList.forEach((serial: any, idx: any) => {
            if (idx === 0) {
              // 替换第一个
              data.seriesBOList[0] = {
                isCheck: true,
                brand: serialDetail.data.brand,
                brandId: serialDetail.data.brandId,
                serialGroupId: serialDetail.data.serialGroupId,
                serialGroupName:
                  setTxtLength(serialDetail.data.serialGroupName, 6) || '',
                serialGroupPic: serialDetail.data.serialGroupPic,
              }
            } else {
              serial.isCheck = false
            }
          })
        }
        methods.toHideSelectCar()
      },
      // 关闭车品牌侧边栏
      toHideSelectCar() {
        data.carSelectVisible = false
      },
      // 选择其他
      selectOther() {
        countAd(6563)
        data.carSelectVisible = true
      },
      // 处理协议勾选
      handleStatement() {
        data.checkBoxNeedVerify = !data.checkBoxNeedVerify
      },
      verlificateForm() {
        let isCheck = data.seriesBOList.some((serial: any) => serial.isCheck)
        if (!isCheck) {
          Toast('请选择车系')
          return false
        }
        if (!data.checkBoxNeedVerify) {
          Toast('请勾选同意《个人信息披露及保护声明》')
          return false
        }

        return true
      },
      // 处理立即领取
      async handleReceive() {
        countAd(6562)

        // 获取加密手机号
        let cookiePhoneObj = getXunJiaInfo3Cookie()
        let sensitivePhone =
          data.postForm.phone.slice(0, 3) +
          '****' +
          data.postForm.phone.slice(7, 11)
        let curPhone = ''
        if (data.postForm.phone.slice(0, 11).includes('*')) {
          curPhone =
            data.browserEnv === 1
              ? store.state.appPhone
                ? store.state.appPhone
                : data.postForm.phone.slice(0, 11)
              : data.postForm.phone.slice(0, 11)
        } else {
          curPhone = data.postForm.phone.slice(0, 11)
        }
        // 有cookie
        if (
          data.browserEnv !== 1 &&
          cookiePhoneObj &&
          cookiePhoneObj.phone &&
          cookiePhoneObj.encryptPhone &&
          cookiePhoneObj.phone === sensitivePhone
        ) {
          data.postForm.encryptPhone = cookiePhoneObj.encryptPhone
        } else {
          let EtguardInfoRes: any = await fetchEncryptInfo({
            phones: window.encryStr(curPhone), // 手动输入的号码
          })
          if (EtguardInfoRes.code === 1) {
            data.postForm.encryptPhone = EtguardInfoRes.msg[0].encrypt
          } else {
            Toast('加密失败')
            return
          }
        }

        let selectedSerialArr: any = []
        if (!methods.verlificateForm()) return
        if (data.browserEnv === 1) {
          // app
          data.postForm.source = 2
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          // h5或微信浏览器
          data.postForm.source = 1
        }

        data.seriesBOList.forEach((serial: any) => {
          if (serial.isCheck) {
            selectedSerialArr.push({
              brand: serial.brand,
              brandId: serial.brandId,
              serialGroupId: serial.serialGroupId,
              serialGroupName: serial.serialGroupName,
              serialGroupPic: serial.serialGroupPic,
            })
          }
        })

        let cityId = 1
        if( data.locationInfo.dataType === 'default'){
          cityId = -1
        }else{
          cityId = data.locationInfo.cityId
        }

        let postForm = {
          actId: Number(route.query.actId),
          playRecordId: (props as any).lotteryResultBO.playRecordId,
          city: data.locationInfo.city,
          cityId: cityId,
          currentFrom: window.location.href,
          locationMessage: data.locationInfo.msg || '', // 城市定位信息:浏览器定位成功/失败,传百度sdk失败状态码
          locationType:
            data.locationInfo.dataType === 'geolocation'
              ? 1
              : data.locationInfo.dataType === 'ipJson'
              ? 2
              : data.locationInfo.dataType === 'user'
              ? 3
              : data.locationInfo.dataType === 'cookie' ||
                data.locationInfo.dataType === 'default'
              ? 0
              : 4, // 城市定位类型:0-其他，1-浏览器定位,2-ip定位,3-用户选择，4-定位失败
          locationVersion: data.locationInfo.version === '2.0.0' ? 2 : 1, // 城市定位版本:1-旧版本,2-新版本
          pcsuv: data.postForm.pcsuv,
          phone: data.postForm.encryptPhone,
          seriesBOList: selectedSerialArr,
          source: data.postForm.source,
          sourceDetail: Number(route.query.sourceDetail),
        }

        const res: any = await postLotteryEnroll(postForm)
        if (res.code === 200) {
          if (res.data.code === 0) {
            methods.toggleTmReceiveRedPacketPopup({
              isShowReceiveRedPacketPopup: false,
            })
            methods.toggleTmReceiveSuccessPopup({
              isShowTmReceiveSuccessPopup: true,
            })
            // data.checkBoxNeedVerify = false
            countAd(6334)
          }
          Toast(res.data.msg)
        } else {
          Toast(res.messsage)
        }
        // 领取成功
      },
      toggleTmReceiveSuccessPopup(obj: any) {
        emit('toggleTmReceiveSuccessPopup', {
          isShowTmReceiveSuccessPopup: obj.isShowTmReceiveSuccessPopup,
        })
      },
      setPcsuv() {
        if (data.browserEnv === 1) {
          // app
          if (data.appLoginCookieValue) {
            methods.getAppUserInfo() // 有cookie情况，需要用accountId设置pcsuv
          } else {
            data.postForm.pcsuv = getCookie('pcsuv')
          }
        } else {
          data.postForm.pcsuv = getCookie('pcsuv')
        }
      },
      saveCookie(postForm: any) {
        // 报名成功-存储手机号，方便下次直接获取
        let cacheInfoType = ''
        if (process.env.VUE_APP_NODE_ENV === 'development') {
          cacheInfoType = 'dev'
        } else if (process.env.VUE_APP_NODE_ENV === 'qa') {
          cacheInfoType = 'qa'
        } else {
          cacheInfoType = 'prod'
        }
        postForm.phone = methods.setPhoneSensitive(postForm.phone)
        window.saveCacheInfo &&
          window.saveCacheInfo(postForm.phone, postForm.encrypt, cacheInfoType)
      },
      setPhoneSensitive(phone: any) {
        return phone.slice(0, 3) + '****' + phone.slice(7)
      },
      //  获取app登录用户信息
      async getAppUserInfo() {
        const res: any = await fetchAppUserInfo()
        if (res.code === 200) {
          data.postForm.phone = res.data.phone
          data.postForm.pcsuv = res.data.id
          methods.saveCookie({ phone: res.data.phone })
        }
      },
      // 处理车系选择
      handleSerailSelect(item: any, index: any) {
        if (!item.isCheck) {
          // 将其余变为未勾选
          data.seriesBOList.forEach((serial: any, idx: any) => {
            if (idx !== index) {
              serial.isCheck = false
            } else {
              serial.isCheck = true
            }
          })
        } else {
          data.seriesBOList[index].isCheck = false
        }
      },
      // 控制弹窗
      toggleTmReceiveRedPacketPopup(obj: any) {
        emit('toggleTmReceiveRedPacketPopup', {
          isShowReceiveRedPacketPopup: obj.isShowReceiveRedPacketPopup,
        })
        if (!obj.isShowReceiveRedPacketPopup) {
          data.checkBoxNeedVerify = false
        }
      },
      // 跳转个人信息保护声明
      toLinkStatement() {
        const appUrl =
          'pcautobrowser://more/?uri=https://www1.pcauto.com.cn/zt/gz20171127/declare/app.html?hiddenShareBtn=1'
        const wapUrl =
          'https://www1.pcauto.com.cn/zt/gz20171127/declare/wap.html'
        const wxUrl =
          'https://www1.pcauto.com.cn/zt/gz20171127/declare/app.html'
        if (data.browserEnv === 3) {
          window.location.href = wapUrl
        } else if (data.browserEnv === 1) {
          window.location.href = appUrl
        } else {
          window.location.href = wxUrl
        }
      },
    }
    onMounted(() => {
      methods.setPcsuv()
    })
    onBeforeMount(() => {
      methods.getVerifyCtrl()
    })
    return {
      ...toRefs(data),
      ...methods,
    }
  },
})
